import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'

const StyledModal = styled(Modal)`
  .modal-header {
    border-bottom: 0;
  }
  .modal-footer {
    border-top: 0;
  }
  .modal-body {
    text-align: center;
  }
  .modal-content {
    border-radius: 10px;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .success-custom-modal {
    justify-self: anchor-center !important;
    width: 330px !important;
    height: 150px !important;
  }
`

const PYWModal = ({
  children,
  headerTitle,
  customClass,
  closeLabel,
  saveLabel,
  size,
  show,
  showCloseButton,
  onHide,
  onSave,
}) => {
  const handleClose = () => onHide(false)
  const handleSave = () => onSave()
  return (
    <StyledModal
      size={size}
      show={show}
      dialogClassName={customClass}
      onHide={handleClose}
      centered
    >
      {headerTitle && (
        <Modal.Header closeButton>
          <Modal.Title>{headerTitle}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{children}</Modal.Body>
      {(onSave || showCloseButton) && (
        <Modal.Footer>
          {showCloseButton && (
            <Button variant="secondary" onClick={handleClose}>
              {closeLabel}
            </Button>
          )}
          <Button variant="primary" onClick={handleSave}>
            {saveLabel}
          </Button>
        </Modal.Footer>
      )}
    </StyledModal>
  )
}

PYWModal.propTypes = {
  headerTitle: PropTypes.string,
  closeLabel: PropTypes.string,
  customClass: PropTypes.string,
  saveLabel: PropTypes.string,
  showCloseButton: PropTypes.bool,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  onSave: PropTypes.func,
}

PYWModal.defaultProps = {
  headerTitle: '',
  closeLabel: 'Close',
  saveLabel: 'Save Changes',
  customClass: '',
  size: 'lg',
  showCloseButton: false,
  onHide: null,
  onSave: null,
}

export default PYWModal
